import { ListCarModelService } from 'application/services/list-car-model'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListCarModel = new ListCarModelService(api)
